import { StandardFonts, rgb } from "pdf-lib";
import { cpStampPlan } from "./cpFieldRules";

// pdf-lib draws with a plain Tj (no kerning), but font.widthOfTextAtSize subtracts kerning pairs: measure glyph by glyph.
export const unkernedWidth = (font) => (text, size) =>
  Array.from(String(text ?? "")).reduce((sum, character) => sum + font.widthOfTextAtSize(character, size), 0);

// ENG-1826: stamps the CP page's fields into the loaded PDF in Helvetica, pdf-lib's default face.
export async function stampCpFields(pdfDoc, resolved, typed) {
  const pages = pdfDoc.getPages();
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const sizes = pages.map((page) => page.getSize());
  cpStampPlan(resolved, typed, sizes, unkernedWidth(font)).forEach(({ pageIndex, text, ...placement }) => {
    pages[pageIndex].drawText(text, { ...placement, font, color: rgb(0, 0, 0) });
  });
}
